import { List } from "lucide-react";
import { extractMarkdownHeadings } from "../markdownOutline";

export function ArticleOutline({ content, scope }: { content: string; scope: string }) {
  const headings = extractMarkdownHeadings(content, scope);
  if (!headings.length) return <aside className="article-outline"><div className="article-outline-title"><List className="w-4 h-4" />大纲</div><p className="text-xs text-[var(--text-tertiary)] leading-5">使用 Markdown 标题后，大纲会显示在这里。</p></aside>;
  return <aside className="article-outline" aria-label="文章大纲">
    <div className="article-outline-title"><List className="w-4 h-4" />大纲</div>
    <nav className="article-outline-nav">
      {headings.map((heading) => <button key={heading.id} type="button" className={`article-outline-item level-${heading.level}`} title={heading.text} onClick={() => document.getElementById(heading.id)?.scrollIntoView({ behavior: "smooth", block: "start" })}>{heading.text}</button>)}
    </nav>
  </aside>;
}
